<template>
  <div>
    <v-dialog width="650" v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between" :style="{ width: '100%' }">
            <div>
              QUÉT MÃ VÀ ĐIỀU CHỈNH DANH SÁCH THEO THỰC TẾ
            </div>
            <div class="cursor-pointer" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-divider class="mb-4" />
        <v-card-text>
          <div>
            <v-text-field
              outlined
              v-if="!loading"
              ref="inputField"
              label="Mã IMEI"
              v-model="imeikey"
              readonly
              hide-details
              :style="{ display: 'none' }"
            />
          </div>
          <BaseListImei :list="matchedList" title="Đã quét" class="mb-4" listType="matched" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="d-flex justify-end" :style="{ width: '100%' }">
            <v-btn color="primary" class="ma-2 white--text" @click="closeDialog" outlined>
              Đóng
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce, get } from 'lodash'
import BaseListImei from './BaseListImei.vue'
export default {
  components: { BaseListImei },
  computed: {
    ...mapState({
      query(state) {
        return state['auditProducts'].query
      }
    })
  },
  data() {
    return {
      loading: true,
      dialog: false,
      imeikey: '',
      scanStatus: 0,
      isChecking: false,
      matchedList: [],
      hasChanged: false,
      item: {}
    }
  },
  methods: {
    ...mapActions({
      fetchImei: 'importDeliveryProduct/fetchImeiIndependent',
      updateImei: 'auditProducts/updateImeiAfterScan',
      fetchAuditProductModel: 'auditProducts/fetchAuditProductModel'
    }),
    async openDialog(item) {
      if (item) {
        this.refresh()
        this.dialog = true
        this.loading = true
        this.item = item
        window.addEventListener('keydown', this.onKeyDown)
        setTimeout(() => {
          this.loading = false
        }, 1000)
      }
    },
    onKeyDown(event) {
      this.scanStatus = 1
      if (this.dialog && event.key !== undefined && event.key.length === 1) {
        this.imeikey += event.key
        event.preventDefault()
      }
    },
    refresh() {
      this.matchedList = []
      this.hasChanged = false
    },
    closeDialog() {
      window.removeEventListener('keydown', this.onKeyDown)
      if (this.hasChanged) this.$emit('onRefresh')
      this.dialog = false
    },
    async onCheckImei(imeiCode) {
      try {
        console.log('imeiCode', imeiCode)
        this.hasChanged = true
        await this.updateImei({
          code: get(this.item, 'code'),
          imei: imeiCode,
          importCheck: this.$route.params.id
        })
        await this.fetchAuditProductModel({ importCheckId: this.$route.params.id, params: { ...this.query } })
        this.matchedList.push(imeiCode)
      } catch (error) {
        console.log(error)
      }
    },
    formatImei(str) {
      return str.replace(/\n/g, '')
    },
    debounce: debounce(async function() {
      try {
        console.log('debounce')
        this.loading = true
        this.onCheckImei(this.formatImei(this.imeikey))
        this.imeikey = ''
        this.scanStatus = 0
        setTimeout(() => {
          this.loading = false
        }, 200)
      } catch (error) {
        this.loading = false
      }
    }, 1000)
  },
  watch: {
    scanStatus: {
      handler(val) {
        if (val === 1) {
          this.debounce()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.bordered {
  border: 1px solid #ddd;
}
</style>
